import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100",
  height: "100",
  viewBox: "0 0 1024 1024"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M323 425.2 511.8 236c13.5-13.5 13.5-28.2 0-41.7l-81.6-81.6c-13.5-13.5-28.2-13.5-41.7 0L10 491.2c-13.5 13.5-13.5 28.2 0 41.7l378.5 378.5c13.5 13.5 28.2 13.5 41.7 0l82.5-82.5c13.5-13.5 13.5-28.2 0-41.7L325.2 599.7zm701 173.6V425.2H306.5v173.6z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }